<template>
  <v-container class="project-view">
    <v-toolbar flat>
      <template v-slot:extension>
        <v-tabs v-model="tab" align-with-title>
          <v-tab v-for="item in items" 
          :key="item.id" 
          :to="item.route">
            {{ item.title }}
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="item in items" 
      :key="item.id"
      :value="item.route"
      >

        <router-view v-if="project"/>

      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import store from "@/store/index"
import { mapState, mapGetters } from "vuex";

export default {

  data() {
    return {
      items: [
        {
          title: this.$i18n.t('projectView.plantProduction'),
          icon: "fas fa-angle-right",
          route: `/projects/${this.$router.currentRoute.params.project_id}/plant`
        },
        {
          title: this.$i18n.t('projectView.animalProduction'),
          icon: "fas fa-angle-right",
          route: `/projects/${this.$router.currentRoute.params.project_id}/animal`
        },
        {
          title: this.$i18n.t('projectView.balance'),
          icon: "fas fa-calculator",
          route: `/projects/${this.$router.currentRoute.params.project_id}/balance`
        },
        {
          title: this.$i18n.t('projectView.demand'),
          icon: "fas fa-calculator",
          route: `/projects/${this.$router.currentRoute.params.project_id}/fulfillment/list`
        },
      ],
      tab: null,
    };
  },

  computed: {
    ...mapState(["project"]),
    ...mapGetters(["regionNames"]),

  },

  beforeRouteEnter: (to, from, next) => {
    if (to || from || next) {
      // make lint happy
      store.dispatch("fetchProject", to.params.project_id);
      next();
    }
  },

  /*
  When the project is left, save the project and set it to null
  */
  beforeRouteLeave: (to, from, next) => {
    if (to ||from ||next) { // make lint happy
      if (!to.params.project_id) {
        store.dispatch('saveProject')
        store.commit('setProject',null)
      }
      next();
    }
  }  
  
};
</script>
